import { House } from "lucide-react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useClientPortalConfigContext } from "../../context/ClientPortalConfig.ctx";
import { ROUTES } from "../../routes";
import Content from "../Layout/Content";

export const NotFound = () => {
    const { clientPortalGuid } = useClientPortalConfigContext();
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Invalid URL - Client Bookings Zanda";
    }, []);

    const navigateHome = () => {
        void navigate(`/clientportal/${clientPortalGuid}/${ROUTES.HOME.urlPath}`);
    };

    return (
        <Content dataTestIdSuffix="not_found" sx={{ alignSelf: "center" }}>
            <Box display="flex" justifyContent="center" padding={3}>
                <Paper>
                    <Stack spacing={3} p={4} alignItems="center">
                        <Box display="flex" flexDirection="column" gap={1}>
                            <Typography variant="heading3" textAlign="center" data-test-id="text_error_title">
                                Whoops! This page doesn&apos;t seem to exist
                            </Typography>
                            <Typography
                                variant="paragraphMediumRegular"
                                textAlign="center"
                                data-test-id="text_error_subtitle"
                            >
                                You might be using an invalid link.
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                background: palette.neutral[50],
                                borderRadius: 1,
                                padding: 2,
                            }}
                            data-test-id="section_error_instructions"
                        >
                            <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                                What can you do?
                            </Typography>
                            <ul style={{ margin: 0 }}>
                                <li>
                                    <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_reload">
                                        Double-check that the link hasn&apos;t expired or been used already.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography
                                        variant="paragraphMediumRegular"
                                        data-test-id="text_instruction_contact"
                                    >
                                        Return to your client portal to book an appointment or view your invoices.
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_reload">
                                        If you&apos;re still having trouble, contact your practice directly for help.
                                    </Typography>
                                </li>
                            </ul>
                        </Box>

                        <Button
                            variant="contained"
                            startIcon={<House size={14} strokeWidth={2} aria-hidden />}
                            onClick={navigateHome}
                            data-test-id="button_home"
                        >
                            Home
                        </Button>
                    </Stack>
                </Paper>
            </Box>
        </Content>
    );
};
